/* tslint:disable */
import { Pipe, PipeTransform } from '@angular/core';

import { NodeType } from '../../classes/tree/IBaseNode';
import { NearbyAssetNode } from '../../classes/tree/nodes/NearbyAssetNode';
import { Tree } from '../../classes/tree/tree';

@Pipe({
    name: 'mcNearbyFilterBy',
    pure: false
})
export class NearbyFilterByPipe implements PipeTransform {
    transform(children: Tree<NearbyAssetNode>[], filter: string, showPrimary: boolean, showSecondary: boolean): any {
        if (!children) {
            return children;
        }

        if (filter) {
            const lower = filter.toLocaleLowerCase();
            children = children.filter(child => {
                let found;
                switch (child.data.nodeType) {
                    case (NodeType.Record):
                        found = child.data.record.find(v => isNaN(v) ? v.toLocaleLowerCase().includes(lower) : v.toString().toLocaleLowerCase().includes(lower));
                        break;
                    case (NodeType.Document):
                        found = child.data.name.toLocaleLowerCase().includes(lower);
                        break;
                    default:
                        found = child.name.toLocaleLowerCase().includes(lower);
                }

                return found;
            });
        }

        const displaySides = [];
        if (showPrimary) {
            displaySides.push('1');
        }

        if (showSecondary) {
            displaySides.push('2');
        }

        return children.filter(child => {
            let found = true;
            if (child.data.nodeType === NodeType.Record) {
                const idx = child.data.columnList.indexOf('SIDE_IND');
                const side = idx !== -1 ? child.data.record[idx] : undefined;
                if (side) {
                    found = displaySides.includes(side);
                }
            }
            return found;
        })
    }
}
